import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ResultService } from 'src/app/services/result/result.service';
declare var $:any;
@Component({
  selector: 'app-entrance-result',
  templateUrl: './entrance-result.component.html',
  styleUrls: ['./entrance-result.component.scss']
})
export class EntranceResultComponent implements OnInit {
  result:{student:string,father:string,course:string,application:string,dob:string,remarks:string,branch:string}[]=[];
  data:{student:string,father:string,course:string,application:string,dob:string,remarks:string,branch:string}={
    student:'',
    father:'',
    course:'',
    application:'',
    dob:'',
    remarks:'',
    branch:''

  };
  alert=false;
  message:string;
  constructor(private service:ResultService) { }

  ngOnInit(): void {
    this.result=this.service.getResult();
    $('.detail').hide();
  }
  onSubmit(form:NgForm){
    $('.detail').hide();
    this.alert=false;
    if(form.invalid){
      return null;
    }
    const id :string=form.value.search;
    const dob:string = form.value.dob;
    this.data = this.result.find(value=> value.application.toLowerCase()===id.toLowerCase());
    if(!this.data){
      $('.detail').hide();
      this.alert=true;
      this.message="Please Enter Valid Application Number!";
      form.reset();
      return
    }
    if(dob.toLowerCase() !== this.data.dob.toLowerCase()){
      $('.detail').hide();
      this.alert = true;
      this.message= 'Either DOB is not valid or You are using wrong Format!'
      form.reset();
      return
    }
    $('.detail').show();
    form.reset();
   
  }
}
